import styled from "styled-components";
import { pxToRem } from "../../../styles/utils";

export const StudentPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${pxToRem(12)};
`;

export const ContentWrapper = styled.div`
  flex: 1;
  background: white;
  border-radius: ${pxToRem(16)};
  box-shadow: 0px ${pxToRem(9)} ${pxToRem(14.5)} rgba(0, 0, 0, 0.06),
    0px 0px ${pxToRem(6)} rgba(31, 10, 53, 0.05);
  padding: ${pxToRem(32)} ${pxToRem(25)};
  box-sizing: border-box;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${pxToRem(32)};
`;

export const Title = styled.h1`
  font-size: ${pxToRem(32)};
  font-weight: 700;
  color: rgb(31, 10, 53);
`;
